export interface GetRequestUrlOpts {
  url: string;
  booleanParams?: Record<string, boolean | undefined>;
  stringParams?: Record<string, string | number | undefined>;
}

export const getRequestUrl = ({ url, booleanParams, stringParams }: GetRequestUrlOpts) => {
  const booleanQueryParams = Object.entries(booleanParams ?? {})
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${value}`);

  const stringQueryParams = Object.entries(stringParams ?? {})
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${value}`);

  const queryParams = [...booleanQueryParams, ...stringQueryParams];

  return `${url}${queryParams.length ? '?' + queryParams.join('&') : ''}`;
};

export const addQueryParamsToUrl = (url: string, params: Record<string, string | number | boolean | undefined>) => {
  const queryParams = Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${value}`);

  return `${url}${queryParams.length ? '?' + queryParams.join('&') : ''}`;
};
